import {
  isProjectSelection,
  TSession,
} from '@fe-learner-common/api/schemas/sessionsSchema';
import { Tag, TagType } from '@fe-learner-common';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faFileCertificate } from '@fortawesome/pro-regular-svg-icons/faFileCertificate';
import { faGraduationCap } from '@fortawesome/pro-regular-svg-icons/faGraduationCap';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons/faCircleInfo';

import { useIntl } from 'react-intl';
type Tag = {
  icon: IconDefinition;
  type: TagType;
  text: string;
};

type Session = Pick<
  TSession,
  'diplomasAvailable' | 'certificatesAvailable' | 'projectType'
>;

export const useSessionTags = (
  session?: Session,
): Record<string, Tag> | null => {
  const intl = useIntl();

  if (!session) {
    return null;
  }

  let tags = {};

  if (isProjectSelection(session)) {
    tags = {
      ...tags,
      selection: {
        icon: faCircleInfo,
        type: 'negative',
        text: intl.formatMessage({ id: 'courses.project.tag.selectCourse' }),
      },
    };
  }

  if (session.diplomasAvailable) {
    tags = {
      ...tags,
      diploma: {
        icon: faGraduationCap,
        type: 'neutral',
        text: intl.formatMessage({ id: 'learner.common.diploma' }),
      },
    };
  }

  if (session.certificatesAvailable) {
    tags = {
      ...tags,
      certificate: {
        icon: faFileCertificate,
        type: 'neutral',
        text: intl.formatMessage({ id: 'learner.common.certificate' }),
      },
    };
  }

  return tags;
};
